import { FormControl, TextField } from '@mui/material';

import type { NodeItem } from '@models/flows';

type FailureNodeConfigProps = {
  currentNode: NodeItem;
  onChange: (data: NodeItem) => void;
};

function FailureNodeConfiguration({ currentNode, onChange }: FailureNodeConfigProps) {
  if (!currentNode) return null;

  const handleValueChange = (rawValue: string) => {
    const value = rawValue === '' ? '' : Number(rawValue);
    onChange({
      ...currentNode,
      code: 'number',
      value,
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <FormControl fullWidth>
        <TextField
          label="Decrease amount by %"
          type="number"
          value={currentNode.value ?? ''}
          onChange={(e) => handleValueChange(e.target.value)}
          sx={{ width: 300 }}
        />
      </FormControl>
    </div>
  );
}

export default FailureNodeConfiguration;
